import { useMemo } from 'react'
import {
  BooleanModifier,
  DateModifier,
  FormModelModifiers,
  SelectOptionModifier,
  SlackUserModifier,
  TextModifier,
} from '../../../containers/SingleSheetV2/model/formModelModifiers'
import { ValidateSingleSheetPropertyValue } from '../../../containers/SingleSheetV2/hooks/formValidation'
import { OnChangeMe } from './useMeFormState'

// 表示専用の項目は編集できないため modifier を持たない。
export const useMeModelModifier = (
  onChangeMe: OnChangeMe,
  validate: ValidateSingleSheetPropertyValue
): FormModelModifiers => {
  return useMemo<FormModelModifiers>(() => {
    const text =
      (
        field:
          | 'iconUrl'
          | 'name'
          | 'nameKana'
          | 'nameAlphabet'
          | 'phoneNumber'
          | 'githubUserName'
      ): TextModifier =>
      v => {
        onChangeMe(field, v ?? '')
        validate(field, v)
      }
    const date =
      (field: 'birthday'): DateModifier =>
      v => {
        onChangeMe(field, v)
        validate(field, v)
      }
    const select =
      (field: 'timezoneId'): SelectOptionModifier =>
      v => {
        onChangeMe(field, v)
        validate(field, v)
      }
    const checkbox =
      (field: 'emailNotification'): BooleanModifier =>
      v => {
        onChangeMe(field, v ?? false)
        validate(field, v)
      }
    const slackUser =
      (field: 'slackUser'): SlackUserModifier =>
      v => {
        onChangeMe(field, v)
        validate(field, v)
      }

    return {
      iconUrl: text('iconUrl'),
      name: text('name'),
      nameKana: text('nameKana'),
      nameAlphabet: text('nameAlphabet'),
      phoneNumber: text('phoneNumber'),
      birthday: date('birthday'),
      timezoneId: select('timezoneId'),
      emailNotification: checkbox('emailNotification'),
      slackUser: slackUser('slackUser'),
      githubUserName: text('githubUserName'),
    }
  }, [onChangeMe, validate])
}
